<!--RECHERCHE DE PRODUITS DECLINAISON-->
<!--<yo-search-produitdeclines></yo-search-produitdeclines>-->

<!--PRODUITS DE LA RECETTE-->
<yo-produitsrecette></yo-produitsrecette>

<!--</ng-container>-->
